import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subscription } from 'rxjs';
import { AppService } from '../../app.service';
import { GtwSnackbarService } from '../../shared/_services/gtw-snackbar.service';
import { UserAdminService } from '../user-admin.service';
import { GlobalService } from '../../global/services/global.service';
import { WorkspaceService } from '../../workspace/workspace.service';
import { resolveRowPayload } from '../../shared/workspace-element-context';
import { AdminScreenContextService } from '../../admin/shared/admin-screen-context.service';
import * as _ from 'lodash-es';
import { GridEventService } from '../../core/grid/services/grid-event.service';
import { UtilityService } from '../../shared/_services/utility.service';
import { UserAccessApprovalService } from '../../admin/components/user-access-approval/user-access-approval.service';
import { JsonObjectFactoryService } from '../../shared/_services/json-object-factory.service';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'gtw-user-business',
    templateUrl: './user-business.component.html',
    styleUrls: ['./user-business.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class UserBusinessComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);


  rowData: any = {};
  @Input() requestApprovalScreen: any;
  @Input() index: any;
  @Output() emitEvent = new EventEmitter<string>();

  private readonly subs = new Subscription();
  user_id: any;
  bizzHierarchies: any;
  defaultGroupObjKey!: number;
  businessAssignNav: any;
  enitiyAssignNav: any;
  loading!: boolean;
  busHierarchyLoading!: boolean;
  busHierarchiesLoading!: boolean;
  busLoading!: boolean;
  entityLoading!: boolean;
  userSettings: any;
  logged_in_user: any;
  legalEntities: any;
  selectedLE!: string;
  txYearScenarioJcdData: any;
  txYearScenarioJcdOptions: any;
  txyear_scenario_jcd!: string;
  taxYear: any;
  scenario: any;
  grpObjKey!: any;
  reportingMonth!: number;
  renderingMode!: number;
  taxYears: any;
  clients: any;
  client_key: any;
  bizzHierGrpObjDetails: any;
  bizzHierGrpObjDetailsMap: any;
  selectedGrpObjKeys: any;
  selectedUserClientsList: any;
  selected_scenario: any;
  selected_jcd_key: any;
  isPreviewAvailable!: boolean;
  previewMode!: number;
  grpObjKeys: any;
  crudLoading!: boolean;
  jcdKey: string = '';
  GENERAL_CONFIG: any;
  baseURLs: any;

  constructor(
    private appService: AppService,
    private UserAdminFactory: UserAdminService,
    private AlertService: GtwSnackbarService,
    private gridEventService: GridEventService,
    private globalServiceRef: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private JsonObjectFactory: JsonObjectFactoryService,
    private userAccessApprovalService: UserAccessApprovalService,
    private utilityService: UtilityService,
    private adminScreenContext: AdminScreenContextService,
  ) { }

  get globalService(): any {
    return {
      globalParams: this.globalServiceRef.global?.globalParams || {},
      inputs: this.globalServiceRef.global?.inputs,
      workspaceFactory: { activeScreen: { data: null } },
      getScenario: (taxYear: any) => this.globalServiceRef.getScenario(taxYear),
      filterParams: {},
    };
  }

  private selectedUserClientsListener?: any;

  ngAfterViewInit(): void {
    this.selectedUserClientsListener = this.gridEventService.on('selectedUserClientsList','client',(event: any,args: any) =>{
      this.selectedUserClientsList = args;
      console.log("vm.selectedUserClientsList ::",this.selectedUserClientsList);
    });
  }

  ngOnInit(): void {
    this.GENERAL_CONFIG = { base_url: environment.base_url || '' };
    this.baseURLs = { admin: environment.admin_api_url || '/admin' };
    this.init();
    let ready = false;
    setTimeout(() => ready = true);
    this.subs.add(
      this.gtwWorkspace.setTabActive.subscribe(() => { if (ready) this.init(); })
    );
    this.subs.add(
      this.globalServiceRef.globalParamsChanged$.subscribe(() => { if (ready) this.init(); })
    );
  }

  ngOnDestroy(): void {
    if (this.selectedUserClientsListener) {
      this.gridEventService.off('selectedUserClientsList', this.selectedUserClientsListener);
      this.selectedUserClientsListener = undefined;
    }
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const raw = resolveRowPayload(this.adminScreenContext, this.gtwWorkspace);
    this.rowData = Array.isArray(raw)
      ? (raw[0] && typeof raw[0] === 'object' ? raw[0] : {})
      : (raw || {});
  }

  init(): void {
    this.applyWorkspaceContext();
    this.user_id = this.rowData?.SSO_ID || this.rowData?.SSO || this.rowData?.user_id || this.rowData?.sso_id || '';
    this.bizzHierarchies = [];
    this.defaultGroupObjKey = 0;
    this.businessAssignNav = [];
    this.enitiyAssignNav = [];
    this.loading = false;
    this.busHierarchyLoading = false;
    this.busHierarchiesLoading = false;
    this.busLoading = false;
    this.entityLoading = false;
    this.userSettings = this.appService.USER_SETTINGS;
    this.logged_in_user = this.userSettings?.user?.sso_id || '';
    this.legalEntities = [];
    this.selectedLE = '';
    this.txYearScenarioJcdData = [];
    this.txYearScenarioJcdOptions = [];
    this.txyear_scenario_jcd = '';

    const globalParams = this.globalServiceRef.global?.globalParams;
    this.taxYear = globalParams?.tax_year || '2020';
    this.scenario = globalParams?.scenario || '40';
    this.grpObjKey = 0;
    this.reportingMonth = 0;
    this.renderingMode = 0;

    this.taxYears = [];
    const user = this.userSettings?.user;
    this.clients = user?.clients || [];
    this.client_key = this.rowData?.selected_client_key
      ?? user?.client_key
      ?? (this.clients.length > 0 ? this.clients[0].client_key : 0);

    this.bizzHierGrpObjDetails = [];
    this.bizzHierGrpObjDetailsMap = [];
    this.selectedGrpObjKeys = [];
    this.selectedUserClientsList = [];
    this.getTaxYearsByClient(this.client_key);
    this.getGroupObjKeyByClientTaxYrJcdScenario();
    this.getObjectKeysByClientAndTaxYear();
    this.getBizzHierGroupObjDetails();
  }


  get uniqueBizzHierGrpObjDetails(): any[] {
    return _.uniqBy(this.bizzHierGrpObjDetails || [], 'GROUP_OBJ_KEY');
  }

  getName($index: any, anObj: any) {
    return `${$index + 1}. Business Hierarchy - ${anObj.TAX_YEAR}`
  }

  trackByGroupObjKey(index: number, item: any): any {
    return item.GROUP_OBJ_KEY;
  }

  onHierarchyAccordionToggle(anObj: any): void {
    const nextOpen = !anObj?.open;
    (this.bizzHierGrpObjDetails || []).forEach((item: any) => {
      if (item.GROUP_OBJ_KEY === anObj?.GROUP_OBJ_KEY) {
        item.open = nextOpen;
      }
    });
  }
  cancelBus() {
    if (this.selectedGrpObjKeys.length > 0) {
      this.getBizzHierarchyByGroupObjKey(this.selectedGrpObjKeys[0]);
    }
  }

  updateSelectedGroupObjKeys(grpObjKey: any, selected_tax_year?: any, selected_scenario?: any, selected_jcd_key?: any) {
    this.selected_scenario = selected_scenario;
    this.selected_jcd_key = selected_jcd_key;

    this.selectedGrpObjKeys = [];
    this.bizzHierarchies = [];

    this.selectedGrpObjKeys.push(grpObjKey);
    this.getBizzHierarchyByGroupObjKey(grpObjKey);

    this.bizzHierGrpObjDetails = (this.bizzHierGrpObjDetails || []).map((item: any) => ({
      ...item,
      selected: item.GROUP_OBJ_KEY === grpObjKey,
      open: item.GROUP_OBJ_KEY === grpObjKey,
    }));
  }

  /**Retrieving Business Hierarchy for given Group Object Key and for given SSO**/
  getBizzHierarchyByGroupObjKey(argGroupObjKey: any) {
    this.busHierarchyLoading = true;
    let data: any = {};
    data.taxyear = this.taxYear;
    data.sso_id = this.logged_in_user;
    data.userSsoId = this.user_id;
    data.grp_obj_key = argGroupObjKey;
    data.isBusHierAssign = 'Y';
    data.clientKey = this.client_key;
    console.log("Data ::", data);
    this.previewMode = 0;

    if (this.taxYear && argGroupObjKey) {
      this.UserAdminFactory.getBizzHierarchyBySsoByGroupObjKey(this.baseURLs, this.utilityService.convertToFormData(data)).pipe(takeUntilDestroyed(this.destroyRef)).subscribe( (data: { callSuccess: string; jsonObject: string | any[]; errorMessage: string; }) => {
        this.busHierarchyLoading = false;
        if (data.callSuccess === "1") {
          if (data.jsonObject.length > 0) {
            this.businessAssignNav = data.jsonObject;
            const record = { group_obj_key: argGroupObjKey, value: this.businessAssignNav, visible: true };
            this.bizzHierarchies = [
              ...this.bizzHierarchies.map((item: any) => ({ ...item, visible: false })),
              record,
            ];
            this.isPreviewAvailable = true;
          } else {
            this.bizzHierarchies = this.bizzHierarchies.map((item: any) => ({ ...item, visible: false }));
            this.AlertService.openSnackBar("No businesses assigned", 'gtw-snackbar--red');
            //+" Group Obj Key: "+argGroupObjKey
          }
        } else {
          if (data.errorMessage === "no access") {
            this.AlertService.openSnackBar("Sorry you do not have access to do the requested action.", 'gtw-snackbar--red');
          } else {
            this.AlertService.openSnackBar("An error has occurred, If you continue to experience this issue please visit the help page to contact support.", 'gtw-snackbar--red');
          }
        }
      });
    } else {
      this.AlertService.openSnackBar("Please make sure Tax Year, Client and Tax Years are selected", 'gtw-snackbar--red');
      this.loading = false;
    }
  }

/** Retrieving All Tax Years Based on Selected Client Key - Populates TAX YEARS Drop Down**/
getTaxYearsByClient(clientKey: number) {
  console.log("Inside getTaxYearsByClient()", clientKey);
  /** Resetting Staged Bizz Hierarchy Data**/

  if (clientKey > 0) {
    this.loading = true;
    let params = { action_code: 'etxzx9', sso_id: this.logged_in_user, client_key: clientKey };

    this.JsonObjectFactory.getJSONObj(this.GENERAL_CONFIG.base_url + '/loadJsonObject', params, this.globalService, null, null).pipe(takeUntilDestroyed(this.destroyRef)).subscribe( (data: { callSuccess: string; jsonObject: any; errorMessage: string; }) => {
      this.loading = false;
      console.log("getTaxYearsByClient() returned Data ::", data);
      if (data.callSuccess === "1") {
        if (data.jsonObject) {
          this.taxYears = _.map(data.jsonObject, 'TAX_YEAR');
        }
        console.log("this.taxYears ::", this.taxYears);

      } else {
        if (data.errorMessage === "no access") {
          this.AlertService.openSnackBar("Sorry you do not have access to retrive Tax Years.", 'gtw-snackbar--red');
        } else {
          this.AlertService.openSnackBar("Unalbe to retrieve Tax Years. If you continue to experience this issue please visit the help page to contact support.", 'gtw-snackbar--red');
        }
      }

    });

  }
}

resetData(argClientKey: any) {
  this.selectedGrpObjKeys = [];
  this.bizzHierarchies = [];
  this.bizzHierGrpObjDetails = [];
  this.defaultGroupObjKey = 0;
  this.getGroupObjKeyByClientTaxYrJcdScenario(); //get default group object key
  this.getObjectKeysByClientAndTaxYear(); //Retrieving All Grp Object Keys for Given Client Key and Tax Year
  this.getBizzHierGroupObjDetails(); //Retrieving all distinct GRP OBJ KEYS for given client across all years
}

/**Retrieving Group Object Details for all Bizz Hierarchies **/
getBizzHierGroupObjDetails() {
  if (this.client_key >= 0) {
    this.busHierarchiesLoading = true;
    let params = { action_code: 'eheat9', sso_id: this.logged_in_user, client_key: this.client_key };

    this.JsonObjectFactory.getJSONObj(this.GENERAL_CONFIG.base_url + '/loadJsonObject', params, this.globalService, null, null).pipe(takeUntilDestroyed(this.destroyRef)).subscribe( (data: { callSuccess: string; jsonObject: any; errorMessage: string; }) => {
      this.busHierarchiesLoading = false;
      console.log("getBizzHierGroupObjDetails() returned Data ::", data);
      if (data.callSuccess === "1") {
        this.bizzHierGrpObjDetails = (data.jsonObject || []).map((item: any) => ({
          ...item,
          selected: item.GROUP_OBJ_KEY === Number(this.defaultGroupObjKey),
          open: item.GROUP_OBJ_KEY === Number(this.defaultGroupObjKey),
        }));
      } else {
        if (data.errorMessage === "no access") {
          this.AlertService.openSnackBar("Sorry you do not have access to retrive Tax Years.", 'gtw-snackbar--red');
        } else {
          this.AlertService.openSnackBar("Unalbe to retrieve Business Hierarchy Group Object Details. If you continue to experience this issue please visit the help page to contact support.", 'gtw-snackbar--red');
        }
      }

    });
  } else {
    this.AlertService.openSnackBar("Please Select Client", 'gtw-snackbar--red');
  }
}


/** Retrieving All Group Obj Keys based on selected Tax Year and Client - To Render Group Obj Master Table on UI**/
getObjectKeysByClientAndTaxYear() {
  console.log("Get Group Obj Key By Tax Year and Client Fired");

  this.grpObjKey = [];
  if (this.taxYear && this.client_key) {
    this.loading = true;
    let params = { action_code: 'etbll9', sso_id: this.logged_in_user, client_key: this.client_key, taxyear: this.taxYear };

    this.JsonObjectFactory.getJSONObj(this.GENERAL_CONFIG.base_url + '/loadJsonObject', params, this.globalService, null, null).pipe(takeUntilDestroyed(this.destroyRef)).subscribe( (data: { callSuccess: string; jsonObject: any; errorMessage: string; }) => {
      this.loading = false;
      if (data.callSuccess === "1") {
        this.grpObjKeys = data.jsonObject;
        this.txYearScenarioJcdOptions = data.jsonObject;
        console.log("this.txYearScenarioJcdOptions ::", this.txYearScenarioJcdOptions);


      } else {
        if (data.errorMessage === "no access") {
          this.AlertService.openSnackBar("Sorry you do not have access to do the requested action.", 'gtw-snackbar--red');
        } else {
          this.AlertService.openSnackBar("An error has occurred, If you continue to experience this issue please visit the help page to contact support.", 'gtw-snackbar--red');
        }
      }
      console.log("getObjectKeyByClientAndTaxYear() returned Data ::", data);
    });

  }
}

/** Retrieving Default Group Obj Key based on TGT_CONFIG Default Tax Year/JCD/Scenario**/
getGroupObjKeyByClientTaxYrJcdScenario() {
  /*if(this.defaultGroupObjKey>0){
    this.updateSelectedGroupObjKeys(Number(this.defaultGroupObjKey));
   }else{
    this.defaultGroupObjKey = SERVER_CONFIG.configSettings.default_bizz_hier_group_obj_key_ge;
   this.updateSelectedGroupObjKeys(Number(this.defaultGroupObjKey));
   }*/

  //Following is commented because Group Object Key will be coming from TGT_CONFIG table
  this.selectedGrpObjKeys = [];


  if (this.taxYear && this.client_key >= 0 && this.scenario) {


    this.loading = true;
    let params = { action_code: 'emall9', sso_id: this.logged_in_user, client_key: this.client_key, taxyear: this.taxYear, default_scenario: this.scenario };

    this.JsonObjectFactory.getJSONObj(this.GENERAL_CONFIG.base_url + '/loadJsonObject', params, this.globalService, null, null).pipe(takeUntilDestroyed(this.destroyRef)).subscribe( (data: { callSuccess: string; jsonObject: string | any[]; errorMessage: string; }) => {
      this.loading = false;
      console.log("getGroupObjKeyByClientTaxYrJcdScenario data::", data);
      if (data.callSuccess === "1") {
        if (data.jsonObject && data.jsonObject.length > 0) {
          this.defaultGroupObjKey = data.jsonObject[0].GROUP_OBJ_KEY;
          if (this.defaultGroupObjKey > 0) {
            this.updateSelectedGroupObjKeys(this.defaultGroupObjKey, data.jsonObject[0].TAX_YEAR, data.jsonObject[0].SCENARIO, data.jsonObject[0].JCD_KEY);
          }
        } else {
          this.AlertService.openSnackBar("No businesses assigned..", 'gtw-snackbar--red');
        }
      } else {
        if (data.errorMessage === "no access") {
          this.AlertService.openSnackBar("Sorry you do not have access to do the requested action.", 'gtw-snackbar--red');
        } else {
          this.AlertService.openSnackBar("An error has occurred, If you continue to experience this issue please visit the help page to contact support.", 'gtw-snackbar--red');
        }
      }
    });
  } else {
    this.AlertService.openSnackBar("Select: Tax Year Client Key and Scenario from Left Nav", 'gtw-snackbar--red');
  }
}

/** Removes all assigned business hierarchies for given SSO**/
removeAll() {
  console.log("Removes all assigned business hierarchies..");
  this.loading = true;
  let params = { action_code: 'ekkkk9', user_sso_id: this.user_id, compliance: 'GTW' };
  console.log("removeAll() params ::", this.utilityService.convertToFormData(params));
  this.JsonObjectFactory.getJSONObj(this.GENERAL_CONFIG.base_url + '/loadJsonObject', params, this.globalService, null, null).pipe(takeUntilDestroyed(this.destroyRef)).subscribe( (data: { callSuccess: string; errorMessage: string; }) => {
    this.loading = false;
    console.log("removeAll data::", data);
    if (data.callSuccess === "1") {
      this.AlertService.openSnackBar("Removed All Business Hierarchies for SSO::" + this.user_id, 'gtw-snackbar--green');
      if (this.defaultGroupObjKey > 0) {
        this.getBizzHierarchyByGroupObjKey(this.defaultGroupObjKey);
      }
    } else {
      if (data.errorMessage === "no access") {
        this.AlertService.openSnackBar("Sorry you do not have access to do the requested action.", 'gtw-snackbar--red');
      } else {
        this.AlertService.openSnackBar("An error has occurred, If you continue to experience this issue please visit the help page to contact support.", 'gtw-snackbar--red');
      }
    }
  });

}

//TODO: SEND BACK BUSINESS(ES) TO DB CALL
saveBus(argGrpObjKey: any) {

  //Logic to find appropriate Bizz hierrachy based on Group Obj Key
  console.log("saveBus() argGrpObjKey ::", argGrpObjKey);
  // let selBizHier = _.find(this.bizzHierarchies, "group_obj_key");
  let selBizHier = _.find(this.bizzHierarchies, { group_obj_key: argGrpObjKey })
  console.log("saveBus() Request received to Save  ::", selBizHier);
  let toBeSavedBizzHier = [];
  let taxYr = "";
  if (selBizHier) {
    toBeSavedBizzHier = selBizHier.value;
    console.log("saveBus() Preparing to Save  ::", toBeSavedBizzHier);
  }

  //GET ALL CHECKED THAT DO NOT HAVE CHILDREN PROPERTIES;
  let selectedArray: {}[] = [];
  let isAll = "N";
  const getSelected = (node: { selected: any; isleaf: number; mekey: any; grpobjkey: any; taxyear: string; children: any; }) => {
    let record: any = {};
    if (node.selected && node.isleaf === 0) {
      isAll = "Y";
      record.ME_KEY = node.mekey;
      record.LE_KEY = '0';
      record.IS_ALL = isAll;
      record.GRP_OBJ_KEY = node.grpobjkey;
      record.TAX_YEAR = node.taxyear;
      taxYr = node.taxyear;
      selectedArray.push(record);

      _.forEach(node.children, function (value, key) {
        getSelected(value)
      });
    } else if (node.selected && node.isleaf === 1) {
      record.ME_KEY = node.mekey;
      record.LE_KEY = '0';
      record.IS_ALL = isAll;
      record.GRP_OBJ_KEY = node.grpobjkey;
      record.TAX_YEAR = node.taxyear;
      taxYr = node.taxyear;
      selectedArray.push(record);
    } else if (node.children) {
      _.forEach(node.children, function (value, key) {
        getSelected(value)
      });
    }
  }
  _.forEach(toBeSavedBizzHier, function (value, key) {
    getSelected(value)
  })
  console.log("saveBus() Bizz Hierarchy for Save :", selectedArray);
  /**Incase user clicked Unassign-All and clicked save, then derive Tax Year from (Left Side) JCD/Scenario Bizz Hierarchy Table **/
  if (selectedArray.length <= 0) {
    _.forEach(this.bizzHierGrpObjDetails, function (item: { selected: any; TAX_YEAR: string; }, index: any) {
      if (item.selected) {
        taxYr = item.TAX_YEAR;
        console.log("Selected Tax Year from Group Obj Details(LeftPanel) ::", taxYr);
      }
    });
  }
  let service = this.JsonObjectFactory;
  let url = this.GENERAL_CONFIG.base_url + "/saveJsonObject?action_code=etbst9";
  let jsonObj = JSON.stringify(selectedArray);
  let jsonSettings = '{}';
  let params: any = _.extend({ jsonObj: jsonObj }, {});
  params = _.extend({ jsonSettings: jsonSettings }, params);
  params.tax_year = taxYr; //GlobalService.globalParams.tax_year; //"2017";
  params.sso_id = this.logged_in_user;
  params.userSsoId = this.user_id;
  params.compliance = "GTW";
  params.grp_obj_key = argGrpObjKey;
  params.scenario = this.selected_scenario;
  params.jcd_key = this.selected_jcd_key;


  console.log("params ::", params);

  if(this.requestApprovalScreen == true){
    console.log("This is only for Request Approval Screen");
    console.log(this.index);
    this.userAccessApprovalService.setBusinessAssignData(this.index, selectedArray);
    this.AlertService.openSnackBar("Business Hierarchy Saved Successfully.", 'gtw-snackbar--green');
  }else{
    service.saveJSON(url, params, this.globalService).pipe(takeUntilDestroyed(this.destroyRef)).subscribe( (data: { callSuccess: string; }) => {
      if (data.callSuccess === "1") {
        console.log(data);
        this.AlertService.openSnackBar("Business Hierarchy Saved Successfully.", 'gtw-snackbar--green');
        this.crudLoading = false;
      } else {
        this.AlertService.openSnackBar("An error has occurred. If this error continues please go to the help page and contact support", 'gtw-snackbar--red');
        this.crudLoading = false;
      }
    });
  }
}

getTxYearScenarioOptions() {
  this.loading = true;
  let params = { action_code: 'dkm185', sso_id: this.logged_in_user };

  this.JsonObjectFactory.getJSONObj(this.GENERAL_CONFIG.base_url + '/loadJsonObject', params, this.globalService, null, null).pipe(takeUntilDestroyed(this.destroyRef)).subscribe( (data: { callSuccess: string; jsonObject: any; errorMessage: string; }) => {
    this.loading = false;
    if (data.callSuccess === "1") {
      this.txYearScenarioJcdData = data.jsonObject;
      _.forEach(data.jsonObject,  (item: { TAX_YEAR: string; SCENARIO: string; JCD_KEY: string; SCENARIO_DESC: string; JURISDICTION_CODE: string; DOMAIN_NAME: string; CHANNEL_NAME: string; }) => {
        let keyItem = item.TAX_YEAR + '-' + item.SCENARIO + '-' + item.JCD_KEY;
        let val = 'TaxYear/Scenario/JCDKey:' + item.TAX_YEAR + '/' + item.SCENARIO + '/' + item.JCD_KEY + '-' + item.SCENARIO_DESC + '/' + item.JURISDICTION_CODE + '/' + item.DOMAIN_NAME + '/' + item.CHANNEL_NAME + ']';
        let record = { keyItem: val };
        console.log("record ::", record);
        this.txYearScenarioJcdOptions.push(record);
        console.log("this.txYearScenarioJcdOptions ::", this.txYearScenarioJcdOptions);
      });
    } else {
      if (data.errorMessage === "no access") {
        this.AlertService.openSnackBar("Sorry you do not have access to do the requested action.", 'gtw-snackbar--red');
      } else {
        this.AlertService.openSnackBar("An error has occurred, If you continue to experience this issue please visit the help page to contact support.", 'gtw-snackbar--red');
      }
    }
    console.log("getTaxYearScenarioJCDKey() returned Data ::", data);
  });

}



getData() {
  let data: any = {};
  this.businessAssignNav = [];
  this.busLoading = true;
  data.isBusHierAssign = 'Y';

  data.tax_year = this.taxYear;
  data.scenario = this.scenario;
  data.jcd_key = this.jcdKey;
  data.userSsoId = this.user_id;
  let isDataAvailable = false;
  if (!data.tax_year || data.tax_year === "" || !data.scenario || data.scenario === "" || !data.jcd_key || data.jcd_key === "") {
    if (this.txYearScenarioJcdData.length > 0) {
      data.tax_year = this.txYearScenarioJcdData[0].TAX_YEAR;
      data.scenario = this.txYearScenarioJcdData[0].SCENARIO;
      data.jcd_key = this.txYearScenarioJcdData[0].JCD_KEY;
      isDataAvailable = true;
    }
  } else {
    isDataAvailable = true;
  }
  if (isDataAvailable) {
    this.UserAdminFactory.getUserBusiness(data).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res: any) => {
      this.busLoading = false;
      if (res.callSuccess === "1") {
        this.businessAssignNav = res.jsonObject;
        if (res.jsonObject.length <= 0) {
          this.AlertService.openSnackBar("No businesses assigned", 'gtw-snackbar--red');
        }
      } else {
        if (res.errorMessage === "no access") {
          this.AlertService.openSnackBar("Sorry you do not have access to do the requested action.", 'gtw-snackbar--red');
        } else {
          this.AlertService.openSnackBar("An error has occurred, If you continue to experience this issue please visit the help page to contact support.", 'gtw-snackbar--red');
        }
      }
    });
  } else {
    this.AlertService.openSnackBar("Tax Year/ Scenario / JCD Key not available.", 'gtw-snackbar--red');
    this.busLoading = false;
  }
}

//getTxYearScenarioOptions();

setTxYearScenarioJcd() {
  console.log("setTxYearScenarioJcd ::", this.txyear_scenario_jcd);
  let itemKey = this.txyear_scenario_jcd.split('-')[0];
  console.log("itemKey ::", itemKey);

  let itemVal = itemKey.split(':')[1];
  console.log("itemVal ::", itemVal);

  this.taxYear = itemVal.split('/')[0];
  this.scenario = itemVal.split('/')[1];
  this.jcdKey = itemVal.split('/')[2];
  console.log("txYr ::", this.taxYear);
  console.log("scnrio ::", this.scenario);
  console.log("jcdKy ::", this.jcdKey);
  this.getData();

}

loadBizzHierarchyData() {
  console.log("loadBizzHierarchyData ::");
}

getEntities() {
  // Dead code path - getUserEntity is not fully migrated in the service.
  // Kept for parity with original (was commented out: //getEntities())
  this.enitiyAssignNav = [];
  this.entityLoading = false;
}

//commented by mallesh
//getEntities()

getLegalEntities(searchKey: any) {
  /*this.legalEntities = [
        {name:"User" , display_name: "User"  },
        {name:"Editor" , display_name: "Editor"},
        {name:"Admin" , display_name: "Admin" },
        {name:"Developer" , display_name: "Developer" },
        {name:"Super Admin" , display_name: "Super Admin" }
    ];*/

  console.log("returning LEs for SearchKEY = ", searchKey);



  this.loading = true;
  let params = { action_code: 'x8vwlj', tax_year: '2016', search_string: searchKey };
  this.JsonObjectFactory.getJSONObj(this.GENERAL_CONFIG.base_url + '/loadJsonObject', params, this.globalService, null, null).pipe(takeUntilDestroyed(this.destroyRef)).subscribe( (data: { jsonObject: any; }) => {
    this.loading = false;
    this.legalEntities = data.jsonObject;
    console.log("getLegalEntities() returned Data ::", data);
  });

  return this.legalEntities;
}

addLE(selectedItem: { DISPLAY_NAME: string; }, searchKey: string) {
  console.log("Selected LE ::", selectedItem);
  this.selectedLE = selectedItem.DISPLAY_NAME;
  //fire query to bring ME for selected LE
  this.enitiyAssignNav = this.legalEntities;

  this.loading = true;
  let params = { action_code: 'x8vwlj', tax_year: '2016', search_string: searchKey };
  this.JsonObjectFactory.getJSONObj(this.GENERAL_CONFIG.base_url + '/loadJsonObject', params, this.globalService, null, null).pipe(takeUntilDestroyed(this.destroyRef)).subscribe( (data: { jsonObject: any; }) => {
    this.loading = false;
    this.legalEntities = data.jsonObject;
    console.log("getLegalEntities() returned Data ::", data);
  });

}

cancelEntity() {
  this.getEntities();
}

//TODO: SEND BACK ENTITIES TO DB CALL
saveEntity() {

  //GET ALL CHECKED THAT DO NOT HAVE CHILDREN PROPERTIES;

  let selectedEntityList = _.filter(this.enitiyAssignNav, { 'selected': true });
  console.log(" selectedEntityList  ", selectedEntityList);

}

}
